import "./loadAssets";

import Vue from "vue";
import log, { Logger } from "loglevel";

import Rollbar from "vue-rollbar";
// import _ from "lodash";
import ice from "./service/Ice/Ice";
import store from "./store";

Vue.config.productionTip = false;

if (window._rollbarConfig) {
  log.debug("window._rollbarConfig", window._rollbarConfig);

  // _rollbarConfig は HTML Blade を参照
  Vue.use(Rollbar, {
    autoInstrument: true,
    accessToken: window._rollbarConfig.accessToken,
    captureUncaught: true,
    captureUnhandledRejections:
      window._rollbarConfig.captureUnhandledRejections,
    enabled: true,
    source_map_enabled: false,
    environment: window._rollbarConfig.environment,
    payload: window._rollbarConfig.payload,
    ignoredMessages: window._rollbarConfig.ignoredMessages,
  });
}

Vue.config.errorHandler = (err, vm, info) => {
  log.error(`Captured in Vue.config.errorHandler: ${info}`, err);
  Vue.rollbar.error(err);
};

new Vue({ store }).$mount("#app");

declare global {
  interface Window {
    library: any;
    ice: any;
    loglevel: Logger;
    _rollbarConfig: any;
  }
  interface WindowScreen extends Screen {
    systemXDPI: number;
    logicalXDPI: number;
  }
}

// window に展開
window.loglevel = log;
window.ice = ice;
